const CDN = 'https://storage.googleapis.com/fr8bot-assets';

export const LANDING_VIDEOS_ORIGIN = CDN;

// H.264 with the moov atom up front: iOS Safari does not play VP9 in MP4, and a trailing moov
// delays the first frame.
export const LANDING_VIDEOS = {
  home: `${CDN}/dc2078a9-b200-4941-ab72-cd61469782cc.mp4`,
  carrier: `${CDN}/d5c48298-a307-4b1c-8549-f606de424b51.mp4`,
  customer: `${CDN}/5b32a7aa-7a96-40fc-b300-56923d4d0c58.mp4`,
  trafficBlack: `${CDN}/8f22f1c7-aac1-41ef-8df5-50677ceaec8f.mp4`,
  trafficWhite: `${CDN}/a691cc9f-810e-48d7-8e44-514f481af186.mp4`,
} as const;
